import { authConditional, composeMiddleware } from "lib/core/routing/middleware"
import get from "lodash/get"
import path from "path-browserify"
import {
  loadResource,
  loadResourcePath,
  loadResourcePathStep
} from "path/middleware"

// TODO: the route isn't in full control of displaying the discussion panel
// (so hitting the back button and then forward will not show the panel, though the route changes)
const onRouteToDiscussion = composeMiddleware(authConditional, (nextState) => {
  const loader =
    nextState.match.params.section === "community"
      ? loadResource
      : loadResourcePath

  return loader(nextState).then(function () {
    const { params } = nextState.match
    window.App.getStore("discussion")
      .action.selectDiscussionResponse(params.discussionId, params.responseId)
      .loadModeratorsForOffering(params.cohortId)

    const {
      view,
      context,
      type,
      types,
      onUpdateDiscussion,
      onDeleteDiscussion
    } = get(nextState, "location.state") || {}

    window.App.request("show:discussion:panel", parseInt(params.discussionId), {
      view: view || "show",
      context,
      type,
      types,
      onUpdateDiscussion,
      onDeleteDiscussion
    })
  })
})

const onRouteToNewDiscussion = (nextState, replaceState) => {
  // We no longer support creating a discussion from the discussion panel on Community.
  // Instead the user can use the inline discussion form.
  if (nextState.match.params.section === "community") {
    return replaceState(path.join(nextState.location.pathname, "../"))
  }

  // TODO: why is onCreateDiscussion undefined?
  const { onCreateDiscussion, type, types } =
    get(nextState, "location.state") || {}

  // default discussion panel options
  const discussionPanelOptions = {
    view: "create",
    onCreateDiscussion,
    type,
    types
  }

  return loadResourcePathStep(nextState).then(() =>
    window.App.request("show:discussion:panel", null, discussionPanelOptions)
  )
}

const onLeaveDiscussion = function (nextState) {
  window.App.getStore("discussion").action.clearSelectedDiscussion()
}

export default [
  {
    path: "new/",
    onEnter: onRouteToNewDiscussion,
    onLeave: onLeaveDiscussion
  },
  {
    // Eh, not sure best way to have an optional non-arg, so setting optional "response" as :response arg
    path: ":discussionId(\\d+)/:response(response)?/:responseId(\\d+)?/",
    onEnter: onRouteToDiscussion,
    onLeave: onLeaveDiscussion
  }
]
